import { memo } from "react";
import { NavLink } from "react-router-dom";
import { Box, Button, Divider, Flex, HStack, Text } from "@chakra-ui/react";
import { AppIcon } from "../../components";
import { NavItem } from "./AppNav";
import { ButtonVariants } from "../../theme/components/button";

interface AppNavItemProps {
    navItem: NavItem;
    variant?: ButtonVariants;
    onlyIcon?: boolean;
    isActive?: boolean;
}

const AppNavItem = ({
    navItem,
    variant,
    onlyIcon,
    isActive,
}: AppNavItemProps) => {
    return (
        <>
            <NavLink
                to={navItem?.url || ""}
                onClick={() => {
                    document
                        ?.querySelectorAll(".rotate-180")
                        .forEach((element) => {
                            element?.classList.remove("rotate-180");
                        });
                }}
                {...(onlyIcon && { title: `${navItem.label}` })}
            >
                <Button
                    isActive={isActive}
                    variant={variant}
                    className={onlyIcon ? "btn-icon-md" : ""}
                    size="sm"
                >
                    <HStack w={"full"} justifyContent={"space-between"}>
                        <HStack gap={5}>
                            {navItem.iconName && (
                                <Box position={"relative"}>
                                    <AppIcon name={navItem.iconName || ""} />
                                    {/* {navItem.count && onlyIcon && (
                                        <Flex
                                            position={"absolute"}
                                            top={"-4px"}
                                            right={"-4px"}
                                            w={4}
                                            h={4}
                                            borderRadius={"full"}
                                            bg={
                                                "var(--chakra-colors-destructive)"
                                            }
                                            justifyContent={"center"}
                                            alignItems={"center"}
                                            zIndex={1}
                                        >
                                            <Text
                                                fontSize={"10px"}
                                                lineHeight={"10px"}
                                                color={
                                                    "var(--chakra-colors-white)"
                                                }
                                            >
                                                {navItem.count}
                                            </Text>
                                        </Flex>
                                    )} */}
                                </Box>
                            )}
                            {!onlyIcon && (
                                <Text as={"span"} fontWeight="normal">
                                    {navItem.label}
                                </Text>
                            )}
                        </HStack>
                        {navItem.count && !onlyIcon && (
                            <Flex
                                w={"20px"}
                                height={"20px"}
                                borderRadius={"full"}
                                bg={"var(--chakra-colors-destructive)"}
                                justifyContent={"center"}
                                alignItems={"center"}
                            >
                                <Text
                                    textStyle={"mediumXs"}
                                    lineHeight={"20px"}
                                    color={"var(--chakra-colors-white)"}
                                >
                                    {navItem.count}
                                </Text>
                            </Flex>
                        )}
                    </HStack>
                </Button>
            </NavLink>
            {navItem?.divider && (
                <Divider
                    orientation="horizontal"
                    my={4}
                    borderColor={"var(--chakra-colors-primaryT80)"}
                    alignSelf={"stretch"}
                />
            )}
        </>
    );
};

export default memo(AppNavItem, (prevProps, nextProps) => {
    return (
        prevProps.isActive === nextProps.isActive &&
        prevProps.onlyIcon === nextProps.onlyIcon &&
        prevProps.navItem.count === nextProps.navItem.count
    );
});
